/** INR amounts use two decimal places (paise precision). */
export const PAISE_PER_RUPEE = 100;

export function roundMoney2(amount: number): number {
    if (!Number.isFinite(amount)) {
        return 0;
    }
    return Math.round((amount + Number.EPSILON) * PAISE_PER_RUPEE) / PAISE_PER_RUPEE;
}

export function rupeesToPaise(rupees: number): number {
    return Math.round(rupees * PAISE_PER_RUPEE);
}

export function paiseToRupees(paise: number): number {
    return roundMoney2(paise / PAISE_PER_RUPEE);
}

/** Percentage with two decimals: 33.33% → 3333 (compare / sum against PERCENTAGE_BASIS_POINTS_MAX). */
export function percentageToBasisPoints(percentage: number): number {
    return Math.round(percentage * 100);
}

export function basisPointsToPercentage(basisPoints: number): number {
    return roundMoney2(basisPoints / 100);
}
